// ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // or 'auto' if you don't want smooth
    });
  }, [pathname]);

  return null; 
}

export default ScrollToTop;